import { defineStore } from 'pinia';

export const useFormsStore = defineStore('forms', {
    state: () => {
        return {
            open: null
        }
    },
    actions: {
        setOpen(open) {
            this.open = open;
        },
        clear() {
            this.open = null;
        }
    }
})